import Button from "@commons/Button";
import ComboBox from "@commons/Input/ComboBox";
import SelectInput from "@commons/Input/Select";
import TextInput from "@commons/Input/Text";
import MapTableSelector from "@commons/Table/TableHeader/MapTableSelector";
import Text from "@commons/Typography/Text";
import SearchIcon from "@mui/icons-material/Search";
import type { ReleasesFilters } from "@services/releases/list/type";
import { searchPpmaUsers } from "@services/users/search";
import type { ComboBoxOption } from "@typings/components/comboBox";
import { MENU_STATUS_OPTIONS } from "@typings/entities/releases/filter";
import { formatOption } from "@utils/formatters";
import { useState } from "react";

type ReleasesFilterProps = {
  filters: ReleasesFilters;
  onChange: (field: keyof ReleasesFilters, value: string) => void;
  onApply: () => void;
};

function ReleasesFilter({ filters, onChange, onApply }: ReleasesFilterProps) {
  const [selectedUser, setSelectedUser] = useState<ComboBoxOption | null>(null);

  return (
    <div>
      <div className="flex flex-col xl:flex-row lg:flex-wrap xl:justify-between xl:items-end gap-4 mb-4">
        <div className="flex justify-center xl:justify-start">
          <MapTableSelector />
        </div>

        <div className="flex flex-col sm:flex-row flex-wrap gap-4">
          <div className="w-full sm:w-auto">
            <div className="mb-2">
              <Text>Período de Soltura</Text>
            </div>
            <div className="flex flex-wrap xs:flex-nowrap gap-4">
              <TextInput
                textSize="small"
                type="datetime-local"
                value={filters.startDate}
                onChange={(e) => onChange("startDate", e.target.value)}
                fullWidth
              />
              <TextInput
                textSize="small"
                type="datetime-local"
                value={filters.endDate}
                onChange={(e) => onChange("endDate", e.target.value)}
                fullWidth
              />
            </div>
          </div>

          <div className="w-full sm:w-auto sm:min-w-36">
            <ComboBox
              value={selectedUser}
              onChange={(option) => {
                setSelectedUser(option);
                onChange("executorId", formatOption(option).value);
              }}
              searchService={searchPpmaUsers}
              label="Agente"
              minSearchLength={0}
              debounceTime={300}
            />
          </div>

          <div className="w-full sm:w-auto sm:min-w-36">
            <SelectInput
              size="small"
              label="Status"
              value={filters.status}
              onChange={(e) => onChange("status", e.target.value as string)}
              options={MENU_STATUS_OPTIONS}
              fullWidth
            />
          </div>

          <div className="w-full sm:w-auto flex items-end">
            <Button
              startIcon={<SearchIcon />}
              customVariant="primary"
              size="full"
              onClick={onApply}
            >
              <Text>Filtrar</Text>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ReleasesFilter;
